function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M100,25.857v78.571c0,5.915-4.799,10.714-10.714,10.714H10.714C4.799,115.143,0,110.344,0,104.429V25.857 c0-5.915,4.799-10.714,10.714-10.714h10.714V3.536c0-1.473,1.205-2.679,2.679-2.679h8.929c1.473,0,2.679,1.205,2.679,2.679v11.607 h28.571V3.536c0-1.473,1.205-2.679,2.679-2.679h8.929c1.473,0,2.679,1.205,2.679,2.679v11.607h10.714 C95.201,15.143,100,19.942,100,25.857z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M12.054,106.929c-2.117,0-3.839-1.723-3.839-3.84V34.071h83.572v69.018c0,2.117-1.723,3.84-3.84,3.84H12.054z"
});

var SvgCalendar1 = function SvgCalendar1(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 116",
    style: {
      enableBackground: "new 0 0 100 116"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCalendar1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar-1.cd1049b5.svg";
export { ForwardRef as ReactComponent };